var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact-container"},[_c('div',{staticClass:"page-info"},[_vm._m(0),_c('div',{staticClass:"info-container"},[_c('div',{staticClass:"form-container"},[_c('ContactForm')],1)])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-title"},[_c('h2',[_vm._v("Επικοινωνία")])])
}]

export { render, staticRenderFns }